export var reduxKey = '@@entities';
//# sourceMappingURL=constants.js.map